// extracted by mini-css-extract-plugin
export var orderSummary = "_u5-0";
export var showMoreLessButton = "_u5-1";